<template>
    <div class="edit_wrap">
        <div class="add_top">
            <div class="add_tab active_tab">合同详情</div>
        </div>

        <div class="pl10 mt20 mb20" v-if="contractForm.schedule">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">审核进展：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content"><span class="main_word">{{ contractForm.schedule.time*1000 | time }}&nbsp;&nbsp;{{ contractForm.schedule.desc}}</span></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content" v-if="contractForm.schedule.content">
                    ({{contractForm.schedule.content}})</div></el-col>
            </el-row>
        </div>
        <div class="mt20 ovh min_height" >
            <div class="pl10 mt20">
                <span class="dib">合同基本信息</span><span class="line"></span>
                <div class="mt20">
                    <el-form label-width="207px" class="demo-ruleForm">
                        <el-form-item label="供应商合同编号："><span>{{ contractForm.contractCode }}</span></el-form-item>
                        <el-form-item label="供应商原合同编号：" v-if="contractForm.parentContractId>0"><span>{{ contractForm.parentContractCode }}</span></el-form-item>
                        <el-form-item label="供应商编号："><span>{{ contractForm.supplierCode }}</span></el-form-item>
                        <el-form-item label="供应商名称："><span>{{ contractForm.supplierName }}</span></el-form-item>
                        <el-form-item label="合作方式：">
                            <span v-if="contractForm.cooperationType == 1" >入仓</span>
                            <span v-if="contractForm.cooperationType == 2">入仓（实销实结）</span>
                            <span v-if="contractForm.cooperationType == 3">自发货</span>
                            <span class="main_word" v-if="snapshot && snapshot.cooperationType">&nbsp;&nbsp;
                                {{ snapshot.cooperationType == 3 ? '自发货' :
                                   snapshot.cooperationType == 2 ? '入仓（实销实结）' :
                                   snapshot.cooperationType == 1 ? '入仓' : ''
                                }}
                            </span>
                        </el-form-item>
                        <el-form-item label="发货时效：" v-if="contractForm.cooperationType == 3">
                            <span>{{ contractForm.deliveryTime }}小时</span>
                            <span class="main_word" v-if="snapshot && snapshot.deliveryTime">&nbsp;
                                {{ snapshot.deliveryTime}}
                            </span>
                        </el-form-item>
                        <el-form-item label="合同开始时间：">
                            <span>{{ contractForm.contractStartDate | time }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.contractStartDate">&nbsp;
                                {{ snapshot.contractStartDate*1000 | time }}
                            </span>
                        </el-form-item>
                        <el-form-item label="合同结束时间：">
                            <span>{{ contractForm.contractEndDate | time }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.contractEndDate">&nbsp;
                                {{ snapshot.contractEndDate*1000 | time }}
                            </span>
                        </el-form-item>
                        <span class="dib">合同条款-财务信息</span><span class="second_line"></span>
                        <el-form-item label="结算主体：">
                            <span v-if="contractForm.settlementBodyId == 1" >北京果敢时代科技有限公司</span>
                            <span v-if="contractForm.settlementBodyId == 2" >MAMA HONG KONG</span>
                            <span v-if="contractForm.settlementBodyId == 3" >天津果敢时代国际贸易有限公司</span>
                            <span v-if="contractForm.settlementBodyId == 4" >正合奇胜（天津）企业咨询管理有限公司</span>
                            <span v-if="contractForm.settlementBodyId == 5" >老师线下打款</span>
                            <span class="main_word" v-if="snapshot && snapshot.settlementBodyId">&nbsp;
                                {{
                                    snapshot.settlementBodyId == 1 ? '北京果敢时代科技有限公司' :
                                    snapshot.settlementBodyId == 2 ? 'MAMA HONG KONG' :
                                    snapshot.settlementBodyId == 3 ? '天津果敢时代国际贸易有限公司' :
                                    snapshot.settlementBodyId == 4 ? '正合奇胜（天津）企业咨询管理有限公司' :
                                      snapshot.settlementBodyId == 5 ? '老师线下打款' : ''
                                }}
                            </span>
                        </el-form-item>
                        <el-form-item label="结算方式：">
                            <span v-if="contractForm.settlementType == 1" >直采</span>
                            <span v-if="contractForm.settlementType == 2" >预付款</span>
                            <span v-if="contractForm.settlementType == 3" >实销实结</span>

                            <span class="main_word" v-if="snapshot && snapshot.settlementType">&nbsp;
                                {{
                                    snapshot.settlementType == 1 ? '直采' :
                                    snapshot.settlementType == 2 ? '预付款' :
                                    snapshot.settlementType == 3 ? '实销实结' : ''
                                }}
                            </span>
                        </el-form-item>
                        <el-form-item label="结算币种：">人民币</el-form-item>
                        <el-form-item v-if="contractForm.settlementType != 2 "label="结算账期：">
                            <span v-if="contractForm.settlementPaymentType==0">{{ contractForm.settlementPaymentDays }}天</span>

                            <span v-if="contractForm.settlementPaymentType && contractForm.settlementPaymentType>=2" label="结算账期：">
                                <span v-if="contractForm.settlementPaymentType==2">按年结算</span>
                                <span v-if="contractForm.settlementPaymentType==3">按半年结算</span>
                                <span v-if="contractForm.settlementPaymentType==4">按季度结算</span>
                                <span v-if="contractForm.settlementPaymentType==5">按月结算</span>
                                <span v-if="contractForm.settlementPaymentType==6">按半月结算</span>
                            </span>

                            <span class="main_word" v-if="snapshot && snapshot.settlementPaymentType>=2">
                                <span v-if="snapshot.settlementPaymentType==2">按年结算</span>
                                <span v-if="snapshot.settlementPaymentType==3">按半年结算</span>
                                <span v-if="snapshot.settlementPaymentType==4">按季度结算</span>
                                <span v-if="snapshot.settlementPaymentType==5">按月结算</span>
                                <span v-if="snapshot.settlementPaymentType==6">按半月结算</span>
                            </span>

                            <span class="main_word" v-if="snapshot && snapshot.settlementPaymentType==0 && snapshot.settlementPaymentDays">
                                {{  snapshot.settlementPaymentDays }}天
                            </span>
                        </el-form-item>

                        <el-form-item v-if="contractForm.settlementType == 2" label="结算账期：">
                            <span v-for="(paymentRate,index) in contractForm.settlementPaymentRate.split(',')">{{index==0?"":","}}第{{index+1}}期{{ paymentRate }}%</span>

                            <span v-if="snapshot && snapshot.settlementType == 2">
                                <span class="main_word" v-for="(paymentRate,index) in snapshot.settlementPaymentRate.split(',')">
                                    {{index==0?"":","}}第{{index+1}}期{{ paymentRate }}%
                                </span>
                            </span>
                        </el-form-item>

                        <el-form-item label="是否需要保证金：">
                            <span>{{ contractForm.shouldDeposit == 0 ? '不需要' : '需要' }}</span>
                        </el-form-item>

                        <el-form-item v-if="contractForm.shouldDeposit == 1" label="保证金：">
                            <span>{{ contractForm.deposit }}人民币</span>
                            <span class="main_word" v-if="snapshot && snapshot.deposit"> {{snapshot.deposit }}人民币</span>
                            <el-button v-if="contractForm.auth.confirmDepositAuth" type="primary" class="mr10" @click="confirmDeposit()">
                                确认收到保证金
                            </el-button>
                        </el-form-item>
                        <el-form-item label="货款支付方式：">甲方将货款直接支付到乙方的如下银行账户</el-form-item>

                        <el-table v-if="contractForm.auth.confirm" :data="contractForm.accounts" border
                                  ref="singleTable" style="width: 90%;margin: 0 auto;margin-bottom:22px;margin-top: 22px" highlight-current-row
                                  @current-change="handleCurrentChange">
                            <el-table-column min-width="100" align="center">
                                <template scope="scope">
                                    <el-radio class="radio" v-model="bankAccountId" :label="scope.row.id">&nbsp;</el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column label="银行开户名" min-width="200" align="center" prop="accountName">
                            </el-table-column>
                            <el-table-column prop="accountNumber" label="银行帐号" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column prop="bankName" label="银行名称" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column v-if="contractForm.registeredCountry != 1" prop="swiftCode" label="SwiftCode" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column v-if="contractForm.registeredCountry == 1" prop="province" label="省" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column v-if="contractForm.registeredCountry == 1" prop="city" label="市" min-width="200" align="center">
                            </el-table-column>
                        </el-table>
                        <el-form-item v-if="!contractForm.auth.confirm && contractForm.account" label="开户银行：">
                            <span>{{ contractForm.account.bankName }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.account"> {{snapshot.account.bankName}}</span>
                        </el-form-item>
                        <el-form-item v-if="!contractForm.auth.confirm && contractForm.account" label="银行账号：">
                            <span>{{ contractForm.account.accountNumber }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.account"> {{snapshot.account.accountNumber}}</span>
                        </el-form-item>
                        <el-form-item v-if="!contractForm.auth.confirm && contractForm.account" label="银行户名：">
                            <span>{{ contractForm.account.accountName }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.account"> {{snapshot.account.accountName}}</span>
                        </el-form-item>
                        <el-form-item v-if="!contractForm.auth.confirm && contractForm.account && contractForm.registeredCountry != 1" label="SwiftCode：">
                            <span>{{ contractForm.account.swiftCode }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.account"> {{snapshot.account.swiftCode}}</span>
                        </el-form-item>
                        <el-form-item v-if="!contractForm.auth.confirm && contractForm.account && contractForm.registeredCountry == 1" label="省：">
                            <span>{{ contractForm.account.province }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.account"> {{snapshot.account.province}}</span>
                        </el-form-item>
                        <el-form-item v-if="!contractForm.auth.confirm && contractForm.account && contractForm.registeredCountry == 1" label="市：">
                            <span>{{ contractForm.account.city }}</span>
                            <span class="main_word" v-if="snapshot && snapshot.account"> {{snapshot.account.city}}</span>
                        </el-form-item>

                        <span class="dib">线上合同信息</span><span class="line"></span>

                        <el-form-item label="合同名称：" >
                            <div style="margin-left: 0px;margin-top: 20px" v-if="contractForm.auth.confirm">
                                <div class="agree_wrap" v-for="val in contractForm.templateContents">
                                    <div class="in_block">
                                        <span class="agree">{{ val.name }}</span>
                                        <el-button type="primary" @click="editAgree(val)">编辑</el-button>
                                    </div>
                                </div>
                            </div>
                            <template v-if="!contractForm.auth.confirm">
                                <span v-for="(content,index) in contractForm.templateContents">
                                    <el-button @click="contentDetail(content)" type="text" size="small">&nbsp;{{content.name}}&nbsp;</el-button>
                                </span>
                            </template>
                        </el-form-item>

                        <el-form-item v-if="contractForm.auth.confirmContractAuth"  label="纸质合同电子版：" class="dib mt20">
                            <span class="f666 f12">请将纸质合同扫描件上传到系统</span>
                            <el-upload action="/suppliers/uploadImages?biz=0" name="pic"
                                       :file-list="contractForm.contractFileArr"
                                       list-type="picture-card"
                                       :on-preview="handlePictureCardPreview"
                                       :on-remove="handleRemove"
                                       :before-upload="beforeUpload"
                                       :on-success="handleSuccess">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
                        </el-form-item>
                        <el-form-item  v-if="contractForm.auth.confirmContractAuth">
                            <el-button   type="primary" class="mr10" @click="confirmContract()">
                                确认证件齐全
                            </el-button>
                        </el-form-item>
                        <el-form-item v-if="contractForm.signContract == 1" label="纸质合同电子版：" class="dib mt20">
                            <div>
                                <img @click="previewPic($event)" class="pic_skan" v-for="contractFile in contractForm.contractFileArr" :src="contractFile">
                            </div>
                        </el-form-item>

                        <!-- 保存 -->
                        <div align="center" class="auto mt10 mb10">
                            <el-button type="primary" class="mr10" @click="cancle">返回</el-button>
                            <el-button v-if="contractForm.auth.confirm" class="mr10" type="primary" @click="supplierConfirm(1)">同意</el-button>
                            <el-button v-if="contractForm.auth.confirm" class="mr10" type="primary" @click="supplierConfirm(2)">不同意</el-button>

                            <el-button v-if="contractForm.auth.saleAudit" class="mr10" type="primary" @click="contractAudit(1,2)">通过</el-button>
                            <el-button v-if="contractForm.auth.saleAudit" class="mr10" type="primary" @click="contractAudit(2,2)">驳回</el-button>

                            <el-button v-if="contractForm.auth.inspectorAudit" class="mr10" type="primary" @click="contractAudit(1,3)">通过</el-button>
                            <el-button v-if="contractForm.auth.inspectorAudit" class="mr10" type="primary" @click="contractAudit(2,3)">驳回</el-button>

                            <el-button v-if="contractForm.auth.forensicAudit" class="mr10" type="primary" @click="contractAudit(1,4)">通过</el-button>
                            <el-button v-if="contractForm.auth.forensicAudit" class="mr10" type="primary" @click="contractAudit(2,4)">驳回</el-button>

                            <el-button v-if="contractForm.auth.financeAudit" class="mr10" type="primary" @click="contractAudit(1,5)">通过</el-button>
                            <el-button v-if="contractForm.auth.financeAudit" class="mr10" type="primary" @click="contractAudit(2,5)">驳回</el-button>
                        </div>
                    </el-form>
                    <el-dialog :visible.sync="dialogVisible" size="small">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                dialogImageUrl:'',
                dialogVisible:false,
                contractId:0,
                bankAccountId:0,
                contractForm: {
                    id: 0,
                    parentContractId:0,
                    parentContractCode:'',
                    supplierName:'',
                    supplierCode:'',
                    contractName: '',
                    contractCode: '',
                    contractStartDate:'',
                    contractEndDate: '',
                    deliveryTime:'',
                    cooperationType:'',
                    settlementBodyId:1,
                    settlementType:'',
                    settlementPaymentTypes:2,
                    settlementPaymentDays: '',
                    settlementPaymentRate:'',
                    settlementPaymentRateArr: [],
                    contractFileArr:[''],
                    shouldDeposit: 1,
                    signDeposit:0,
                    bankAccountId:0,
                    deposit: '',
                    accounts:[],
                    account:{},
                    templateContents: [],
                    templateContentIds:[],
                    auth:{
                        view:false,
                        edit:false,
                        del:false,
                        push:false,
                        confirm:false,
                        saleAudit:false,
                        inspectorAudit:false,
                        forensicAudit:false,
                        financeAudit:false,
                        confirmDepositAuth:false,
                        confirmContractAuth:false
                    },
                    schedule:null
                },
                snapshot:null
            };
        },
        methods: {
            contentDetail(val){
                window.open("/suppliers/index2/#/" + val.fileName + "_view?type=2&contentId=" + val.contentId + "&templateId=" + val.templateId + "&parentContractId=" + this.contractForm.parentContractId);
            },
            editAgree(val){
                window.open("/suppliers/index2/#/" + val.fileName + "_edit?type=2&contentId=" + val.contentId +
                    "&templateId=" + val.templateId +
                    "&parentContractId=" + this.contractForm.parentContractId +
                    "&editType=2"
                );
            },
            confirmDeposit(){
                if(!this.contractId || this.contractId<0) {
                    this.$message.error('未知合同协议ID');
                    return;
                }
                var that = this;
                this.$prompt('请输入备注信息', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入备注信息'
                }).then(({ value }) => {
                    if(!value || value == ""){
                        that.$message.error('备注信息必须填写');
                        return false;
                    }
                    $.get({
                        url: '/suppliers/agreementApply/contractApply/deposit',
                        data: {
                            contractId: that.contractId,
                            content:value
                        },
                        success: function(result) {
                            if (!result.code) {
                                that.$message({
                                    message: '确认收到保证金成功',
                                    type: 'success'
                                });
                                that.fetch();
                            } else {
                                that.$message.error('确认收到保证金失败，请联系管理员');
                            }
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消确认保证金'
                    });
                });
            },
            confirmContract(){
                if(!this.contractId || this.contractId<0) {
                    this.$message.error('未知合同协议ID');
                    return;
                }
                if(!this.contractForm.contractFileArr || this.contractForm.contractFileArr.length<=0) {
                    this.$message.error('请务必上传上传全部合同扫描件图片到系统');
                    return;
                }
                var fileArr = this.fileTransToArray(this.contractForm.contractFileArr);
                var that = this;
                $.get({
                    url: '/suppliers/agreementApply/contractApply/contract',
                    data: {
                        contractId: that.contractId,
                        contractFileArr : fileArr
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '确认收到合同文件成功',
                                type: 'success'
                            });
                            that.fetch();
                        } else {
                            that.$message.error('确认收到合同文件失败，请联系管理员');
                        }
                    }
                })
            },
            contractAudit(auditType,operType){
                this.auditCommon(
                    auditType,
                    operType,
                    '/suppliers/agreementApply/contractApply/audit',
                    auditType === 1 ? '审核通过' : '驳回合同',
                    auditType === 1 ? '请输入审核备注' : '请输入驳回原因'
                );
            },
            supplierConfirm(auditType){
                this.auditCommon(
                    auditType,
                    1,
                    '/suppliers/agreementApply/contractApply/supplierConfirm?bankAccountId='+this.bankAccountId,
                    auditType === 1 ? '同意合同' : '驳回合同',
                    auditType === 1 ? '请输入审核备注' : '请输入驳回原因'
                );
            },
            fetch () {
                var that = this;
                $.get({
                    url: '/suppliers/agreementApply/contractApply/detail',
                    data: {
                        contractId: that.contractId
                    },
                    success: function(result) {
                        if (!result.code) {
                            console.log(result);
                            that.contractForm = result.data.agreement;
                            that.snapshot = result.data.snapshot;
                            if(that.contractForm.contractStartDate ){that.contractForm.contractStartDate = that.contractForm.contractStartDate*1000;}
                            if(that.contractForm.contractEndDate){that.contractForm.contractEndDate = that.contractForm.contractEndDate*1000;}
                            that.bankAccountId = that.contractForm.bankAccountId;
                            console.log(that.contractForm);
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            auditCommon(auditType,operType,url,title,desc){
                var that = this;
                var option = {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                };

                if(auditType === 2){
                    option['inputValidator'] = function(val){return (val==null || val.trim().length<1) ?false:true};
                    option['inputErrorMessage'] =  '请输入驳回原因';
                }
                this.$prompt(desc, title, option).then(({ value }) => {
                    $.get({
                        url: url,
                        data: {
                            auditType : auditType,
                            operType : operType,
                            agreementApplyId : that.contractId,
                            reason:value
                        },
                        success: function(result) {
                            if (!result.code) {
                                that.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                that.fetch();
                            } else {
                                that.showErrorMsg(result.msg, '审核失败，请联系管理员');
                            }
                        }
                    })
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消审核'
                    });
                });
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 预览图片
            previewPic (e) {
                this.dialogVisible = true;
                this.dialogImageUrl = e.currentTarget.src;
            },
            // 删除 上传图片
            handleRemove(file, fileList) {
                this.contractForm.contractFileArr = fileList;
                console.log(fileList);
                console.log(file, fileList);
            },
            handleSuccess(response, file) {
                if (!response.code) {
                    this.contractForm.contractFileArr.push({url:response.data});
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },
            fileTransToArray(files){
                var fileArray = [];
                if(files) {
                    for(var i=0;i<files.length;i++) {
                        if(files[i].url){
                            fileArray.push(files[i].url);
                        }
                    }
                }
                return fileArray;
            },
            handleCurrentChange(val) {
                this.bankAccountId = val.id;
            },
            showErrorMsg(msg,defaultMsg){
                if(msg) {
                    this.$message.error(msg);
                }else{
                    this.$message.error(defaultMsg);
                }
            },
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                console.log(isJPG)
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }
            },
            cancle(){
                window.close();
            }
        },
        mounted () {
            var contractId=this.$route.query.contractId;
            this.contractId = contractId;
            this.fetch();
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
        margin-left: 3%;
        display: inline-block;
        width: 85%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }
    .second_line {
        margin-left: 3%;
        display: inline-block;
        width: 81.8%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }
    .word_num {
        display: inline-block;
        vertical-align: bottom;
        margin-bottom: 22px;
        margin-left: 5px;
        color: #666;
    }
    .pic_tip {
        font-size: 12px;
        color: #ff4949;
        line-height: 1px;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }
    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .pic_min_skan {
        width: 60px;
        height: 60px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .form_color {
        color: rgb(106, 72, 77);
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
        .edit_tab {
            display: inline-block;
            width: 262px;
            height: 46px;
            text-align: center;
            line-height: 46px;
            color: #fff;
            background: #ff6c83;
        }
        .tip_word {
            margin-top: 20px;
            width: 1048px;
            height: 160px;
            background: #f9f9f9;
            padding: 10px;
        }
    }
    .agree_wrap {
        display: inline-block;
    }
    .in_block {
        margin-left: 20px;
    }
    .add_top {
        width: 100%;
        height: 40px;
        background-color: #f9f9f9;
    }
    .add_tab {
        display: inline-block;
        width: 170px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #666;
        font-size: 14px;
        cursor: pointer;
    }
    .active_tab {
        border-bottom: 1px solid #ff4a7d;
        color: #ff4a7d;
    }
</style>


// WEBPACK FOOTER //
// agreement_view.vue?55621a20